import React from 'react';

interface HeadingProps {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
    children: React.ReactNode;
    className?: string;
    variant?: 'primary' | 'secondary' | 'dark' | 'light';
}

export const Heading: React.FC<HeadingProps> = ({
    level = 2,
    children,
    className = '',
    variant = 'primary'
}) => {
    const Tag = `h${level}` as keyof JSX.IntrinsicElements;

    const baseStyles = 'font-roboto font-bold uppercase tracking-tight';

    const variants: Record<string, string> = {
        primary: 'text-primary dark:text-on-surface-dark',
        secondary: 'text-secondary dark:text-secondary-light',
        dark: 'text-heading dark:text-on-surface-dark',
        light: 'text-white',
    };

    const sizes: Record<number, string> = {
        1: 'text-3xl md:text-4xl lg:text-5xl',
        2: 'text-2xl md:text-3xl lg:text-4xl',
        3: 'text-xl md:text-2xl lg:text-3xl',
        4: 'text-lg md:text-xl',
        5: 'text-base md:text-lg',
        6: 'text-sm md:text-base',
    };

    return (
        <Tag className={`${baseStyles} ${variants[variant]} ${sizes[level]} ${className}`}>
            {children}
        </Tag>
    );
};
